<template>
  <div class="text-xs-center">
    <v-dialog v-model="open_close" width="500" scrollable>
      <v-card>
        <v-card-title class="headline" primary-title>{{ title_modal_client }}</v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-form @submit.prevent="save">
            <v-text-field v-model="name" label="Name" v-validate="'required|max:75'" :error-messages="errors.collect('name')" data-vv-name="name"></v-text-field>
            <v-text-field v-model="identifier" label="Identifier" v-validate="'required|max:16'" :error-messages="errors.collect('identifier')" data-vv-name="identifier"></v-text-field>
            <v-textarea v-model="description" v-validate="'max:190'" :error-messages="errors.collect('description')" data-vv-name="description" label="Description" rows="2"></v-textarea>
            <v-text-field label="Logo" @click="pickFile('L')" v-model="logo" prepend-icon="attach_file"></v-text-field>
            <input type="file" style="display: none" ref="inputLogo" accept="image/*" @change="onFilePicked">
            <v-text-field label="Background survey" @click="pickFile('B')" v-model="background" prepend-icon="attach_file"></v-text-field>
            <input type="file" style="display: none" ref="inputBackground" accept="image/*" @change="onFilePickedBackground">
            <v-text-field v-model="color" label="Color"></v-text-field>
            <v-radio-group v-model="client.order_smileys" row>
              <v-radio label="Right" value="right" ></v-radio>
              <v-radio label="Left" value="left"></v-radio>
              <v-radio label="Random" value="random"></v-radio>
              <v-tooltip top>
                <v-btn slot="activator" icon>
                  <v-icon color="grey lighten-1">info</v-icon>
                </v-btn>
                <span>This option will indicate the order in questions type SMILEYS</span>
              </v-tooltip>
            </v-radio-group>
             <v-switch
                :label="'Hidden logo Knower'"
                v-model="client.hidden_logo_knower"
              ></v-switch>           
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="save">Save</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  data () {
    return {
      logo: '',
      file: null,
      background: '',
      backgroundFile: null,
    };
  },
  computed: {
    ...mapGetters(['open_modal_client', 'client_index', 'title_modal_client', 'loading', 'client', 'name_client', 'identifier_client', 'description_client', 'color_client', 'clients']),
    open_close: {
      get () {
        return this.$store.state.client.open_modal_client;
      },
      set (val) {
        this.$store.dispatch('setOpenModalclient', val);
      }
    },
    name: {
      get () {
        return this.$store.state.client.name_client;
      },
      set (val) {
        this.$store.dispatch('setNameClient', val);
      }
    },
    identifier: {
      get () {
        return this.$store.state.client.identifier_client;
      },
      set (val) {
        this.$store.dispatch('setIdentifierClient', val);
      }
    },
    description: {
      get () {
        return this.$store.state.client.description_client;
      },
      set (val) {
        this.$store.dispatch('setDescriptionClient', val);
      }
    },
    color: {
      get () {
        return this.$store.state.client.color_client;
      },
      set (val) {
        this.$store.dispatch('setColorClient', val);
      }
    }
  },
  methods: {
    pickFile (type) {
      if (type === 'L') {
        this.$refs.inputLogo.click();
      } else {
        this.$refs.inputBackground.click();
      }
    },
    onFilePicked (e) {
      const files = e.target.files;
      if (files[0] !== undefined) {
        this.logo = files[0].name;
        if (this.logo.lastIndexOf('.') <= 0) {
          return;
        }
        const fr = new FileReader();
        fr.readAsDataURL(files[0]);
        fr.addEventListener('load', () => {
          this.file = files[0];
        });
      } else {
        this.logo = '';
        this.logo = '';
      }
    },
    onFilePickedBackground (e) {
      const files = e.target.files;
      if (files[0] !== undefined) {
        this.background = files[0].name;
        if (this.background.lastIndexOf('.') <= 0) {
          return;
        }
        const fr = new FileReader();
        fr.readAsDataURL(files[0]);
        fr.addEventListener('load', () => {
          this.backgroundFile = files[0];
        });
      } else {
        this.background = '';
        this.background = '';
      }
    },
    clearData () {
      this.file = null;
      this.backgroundFile = null;
      this.name = '';
      this.identifier = '';
      this.description = '';
      this.logo = '';
      this.color = '';
      this.background = '';
    },
    save () {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.$store.dispatch('setLoading', true);
          let payload = new FormData();
          payload.append('name', this.name);
          payload.append('identifier', this.identifier);
          payload.append('description', this.description);
          payload.append('color', this.color);
          payload.append('order_smileys', this.client.order_smileys ? this.client.order_smileys : 'random');
          payload.append('hidden_logo_knower', this.client.hidden_logo_knower);
          if (this.file) {
            payload.append('logo', this.file);
          }
          if (this.backgroundFile) {
            payload.append('background', this.backgroundFile);
          }
          const index = this.$store.state.client.client_index;
          let url = '';
          if (!index) {
            url = 'client/store';
            window.axios.post(url, payload).then(response => {
              const data = response.data.data;
              this.$store.dispatch('setLoading', false);
              this.$store.dispatch('setOpenModalclient', false);
              this.$store.dispatch('addClient', data);
              this.$store.dispatch('setSnackbar', {
                show: true,
                color: 'success',
                text: 'Customer added correctly. Your admin user is : ' + data.user
              });
              this.clearData();
            });
          } else {
            url = `client/${this.client.id}/update`;
            window.axios.post(url, payload).then(response => {
              const data = response.data.data;
              const temp = this.clients.map(client => {
                if (client.id === this.client.id) {
                  client.name = data.name;
                  client.description = data.description;
                  client.identifier = data.identifier;
                  client.color = data.color;
                  client.logo = data.logo ? true : false;
                  client.background = data.background ? true : false;
                  client.order_smileys = data.order_smileys;
                  client.hidden_logo_knower = data.hidden_logo_knower;
                }
                return client;
              });
              this.$store.dispatch('setClients', temp);
              this.$store.dispatch('setLoading', false);
              this.$store.dispatch('setOpenModalclient', false);
              this.clearData();
            });
          }
        } else {
          this.$store.dispatch('setSnackbar', {
            show: true,
            color: 'info',
            text: 'Check the form, please.'
          });
        }
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/admin/clients/ModalCreateEdit.vue